document.addEventListener('DOMContentLoaded', function () {
    const banner = document.querySelector('.persistent-banner-wrapper');

    if (!banner) return;

    // Show the banner when the user scrolls past the initial viewport height
    function handleScroll() {
        const scrollY = window.scrollY || document.documentElement.scrollTop;

        if (scrollY > window.innerHeight) {
            document.body.classList.add('show-banner');
        } else {
            document.body.classList.remove('show-banner');
        }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
});
